import React, { useEffect } from "react";
import { trackEvent, EVENT_TYPE_PAGE } from "../utils/trackEvent.jsx";

function CaseStudies() {
  useEffect(() => {
    trackEvent(EVENT_TYPE_PAGE);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#f8fafc] to-[#e2e8f0] py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto text-center">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden p-8 md:p-12">
          <div className="w-16 h-16 rounded-full bg-[#1a4a1a]/10 flex items-center justify-center mx-auto mb-6">
            <svg className="w-8 h-8 text-[#1a4a1a]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-[#1a4a1a] mb-4">
            Case Studies Coming Soon
          </h2>
          <p className="text-[#1a4a1a]/90 text-lg mb-8 max-w-2xl mx-auto">
            We're preparing real-world success stories of businesses and nonprofits that have grown with Islamic financing. These case studies will showcase how our partners have helped organizations achieve their goals while maintaining Islamic financing principles.
          </p>
          <div className="text-sm text-[#1a4a1a]/70 mt-6">
            Want to share your success story? Contact us at <a href="mailto:salaam@halalcred.com" className="font-semibold hover:text-[#1a4a1a] underline">salaam@halalcred.com</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CaseStudies; 